/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ImportSession } from './ImportSession';
import {
    ImportSessionFromJSON,
    ImportSessionFromJSONTyped,
    ImportSessionToJSON,
    ImportSessionToJSONTyped,
} from './ImportSession';
import type { Role } from './Role';
import {
    RoleFromJSON,
    RoleFromJSONTyped,
    RoleToJSON,
    RoleToJSONTyped,
} from './Role';

/**
 * 
 * @export
 * @interface ApplicationUser
 */
export interface ApplicationUser {
    /**
     * 
     * @type {string}
     * @memberof ApplicationUser
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUser
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUser
     */
    normalizedUserName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUser
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUser
     */
    normalizedEmail?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUser
     */
    emailConfirmed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUser
     */
    passwordHash?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUser
     */
    securityStamp?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUser
     */
    concurrencyStamp?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUser
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUser
     */
    phoneNumberConfirmed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUser
     */
    twoFactorEnabled?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ApplicationUser
     */
    lockoutEnd?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUser
     */
    lockoutEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ApplicationUser
     */
    accessFailedCount?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUser
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUser
     */
    lastName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ApplicationUser
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ApplicationUser
     */
    lastLoginAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ApplicationUser
     */
    lastActivity?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ApplicationUser
     */
    deletedAt?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationUser
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUser
     */
    passwordSetupToken?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ApplicationUser
     */
    passwordSetupTokenExpiry?: Date | null;
    /**
     * 
     * @type {Array<Role>}
     * @memberof ApplicationUser
     */
    roles?: Array<Role> | null;
    /**
     * 
     * @type {Array<ImportSession>}
     * @memberof ApplicationUser
     */
    importSessions?: Array<ImportSession> | null;
}

/**
 * Check if a given object implements the ApplicationUser interface.
 */
export function instanceOfApplicationUser(value: object): value is ApplicationUser {
    return true;
}

export function ApplicationUserFromJSON(json: any): ApplicationUser {
    return ApplicationUserFromJSONTyped(json, false);
}

export function ApplicationUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'normalizedUserName': json['normalizedUserName'] == null ? undefined : json['normalizedUserName'],
        'email': json['email'] == null ? undefined : json['email'],
        'normalizedEmail': json['normalizedEmail'] == null ? undefined : json['normalizedEmail'],
        'emailConfirmed': json['emailConfirmed'] == null ? undefined : json['emailConfirmed'],
        'passwordHash': json['passwordHash'] == null ? undefined : json['passwordHash'],
        'securityStamp': json['securityStamp'] == null ? undefined : json['securityStamp'],
        'concurrencyStamp': json['concurrencyStamp'] == null ? undefined : json['concurrencyStamp'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'phoneNumberConfirmed': json['phoneNumberConfirmed'] == null ? undefined : json['phoneNumberConfirmed'],
        'twoFactorEnabled': json['twoFactorEnabled'] == null ? undefined : json['twoFactorEnabled'],
        'lockoutEnd': json['lockoutEnd'] == null ? undefined : (new Date(json['lockoutEnd'])),
        'lockoutEnabled': json['lockoutEnabled'] == null ? undefined : json['lockoutEnabled'],
        'accessFailedCount': json['accessFailedCount'] == null ? undefined : json['accessFailedCount'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'lastLoginAt': json['lastLoginAt'] == null ? undefined : (new Date(json['lastLoginAt'])),
        'lastActivity': json['lastActivity'] == null ? undefined : (new Date(json['lastActivity'])),
        'deletedAt': json['deletedAt'] == null ? undefined : (new Date(json['deletedAt'])),
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'passwordSetupToken': json['passwordSetupToken'] == null ? undefined : json['passwordSetupToken'],
        'passwordSetupTokenExpiry': json['passwordSetupTokenExpiry'] == null ? undefined : (new Date(json['passwordSetupTokenExpiry'])),
        'roles': json['roles'] == null ? undefined : ((json['roles'] as Array<any>).map(RoleFromJSON)),
        'importSessions': json['importSessions'] == null ? undefined : ((json['importSessions'] as Array<any>).map(ImportSessionFromJSON)),
    };
}

export function ApplicationUserToJSON(json: any): ApplicationUser {
    return ApplicationUserToJSONTyped(json, false);
}

export function ApplicationUserToJSONTyped(value?: ApplicationUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userName': value['userName'],
        'normalizedUserName': value['normalizedUserName'],
        'email': value['email'],
        'normalizedEmail': value['normalizedEmail'],
        'emailConfirmed': value['emailConfirmed'],
        'passwordHash': value['passwordHash'],
        'securityStamp': value['securityStamp'],
        'concurrencyStamp': value['concurrencyStamp'],
        'phoneNumber': value['phoneNumber'],
        'phoneNumberConfirmed': value['phoneNumberConfirmed'],
        'twoFactorEnabled': value['twoFactorEnabled'],
        'lockoutEnd': value['lockoutEnd'] == null ? value['lockoutEnd'] : value['lockoutEnd'].toISOString(),
        'lockoutEnabled': value['lockoutEnabled'],
        'accessFailedCount': value['accessFailedCount'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'lastLoginAt': value['lastLoginAt'] == null ? value['lastLoginAt'] : value['lastLoginAt'].toISOString(),
        'lastActivity': value['lastActivity'] == null ? value['lastActivity'] : value['lastActivity'].toISOString(),
        'deletedAt': value['deletedAt'] == null ? value['deletedAt'] : value['deletedAt'].toISOString(),
        'isActive': value['isActive'],
        'passwordSetupToken': value['passwordSetupToken'],
        'passwordSetupTokenExpiry': value['passwordSetupTokenExpiry'] == null ? value['passwordSetupTokenExpiry'] : value['passwordSetupTokenExpiry'].toISOString(),
        'roles': value['roles'] == null ? undefined : ((value['roles'] as Array<any>).map(RoleToJSON)),
        'importSessions': value['importSessions'] == null ? undefined : ((value['importSessions'] as Array<any>).map(ImportSessionToJSON)),
    };
}

